import PressableIcon from '@ui/buttons/PressableIcon'
import { colors } from '@ui/colors'
import { LinearGradient } from 'expo-linear-gradient'
import Animated, { Easing, FadeIn, FadeOut } from 'react-native-reanimated'
import cn from '@ui/utils/cn'

type ArrowOverlayProps = {
  direction: 'left' | 'right'
  onPress: () => void
  itemWidth?: number
}

export default function ArrowOverlay({
  direction,
  onPress,
  itemWidth = 128,
}: ArrowOverlayProps) {
  const isLeft = direction === 'left'

  return (
    <Animated.View
      className={cn(
        'pointer-events-box-none absolute bottom-0 top-0 justify-center',
        isLeft ? 'left-0' : 'right-0'
      )}
      entering={FadeIn.duration(300).easing(Easing.in(Easing.ease))}
      exiting={FadeOut.duration(300)}
    >
      <LinearGradient
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        colors={
          isLeft ? [colors.white, colors.white0] : [colors.white0, colors.white]
        }
        style={{
          pointerEvents: 'none',
          position: 'absolute',
          top: 0,
          left: isLeft ? 0 : undefined,
          right: isLeft ? undefined : 0,
          bottom: 0,
          width: itemWidth * 2,
        }}
      />
      <PressableIcon
        name={isLeft ? 'chevron-left' : 'chevron-right'}
        className={cn(
          'pointer-events-auto rounded-full border border-black/10 bg-white',
          isLeft ? 'left-8' : 'right-8'
        )}
        size={48}
        onPress={onPress}
      />
    </Animated.View>
  )
}
